import { render } from "./feedback-list-page.vue?vue&type=template&id=0cd8727d&scoped=true"
import script from "./feedback-list-page.vue?vue&type=script&lang=js"
export * from "./feedback-list-page.vue?vue&type=script&lang=js"

import "./feedback-list-page.vue?vue&type=style&index=0&id=0cd8727d&scoped=true&lang=css"

import exportComponent from "/Users/apple/Documents/Full Stack Projects/elghoneimy-service-fullstack/source/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cd8727d"]])

export default __exports__